<mat-expansion-panel class="[&_::after]:border-primary-900">
  <mat-expansion-panel-header>
    <mat-panel-title>
      {{ entry().question }}
    </mat-panel-title>
  </mat-expansion-panel-header>
  <p class="border-t border-solid border-primary py-4">
    <markdown [data]="entry().answer" [inline]="true"></markdown>
  </p>
</mat-expansion-panel>
